import { colors } from 'baseui/tokens';
export type Theme = 'Dark' | 'Light';
export type HueShades = {
  solid: string;
  light: string;
};
export function getColorPalette(theme: Theme): HueShades[] {
  const isLightTheme = theme === 'Light';
  const red = {
    solid: isLightTheme ? colors.red500 : colors.red500Dark,
    light: isLightTheme ? colors.red100 : colors.red100Dark
  };
  const orange = {
    solid: isLightTheme ? colors.orange500 : colors.orange500Dark,
    light: isLightTheme ? colors.orange100 : colors.orange100Dark
  };
  const amber = {
    solid: isLightTheme ? colors.amber500 : colors.amber500Dark,
    light: isLightTheme ? colors.amber100 : colors.amber100Dark
  };
  const yellow = {
    solid: isLightTheme ? colors.yellow500 : colors.yellow500Dark,
    light: isLightTheme ? colors.yellow100 : colors.yellow100Dark
  };
  const lime = {
    solid: isLightTheme ? colors.lime500 : colors.lime500Dark,
    light: isLightTheme ? colors.lime100 : colors.lime100Dark
  };
  const green = {
    solid: isLightTheme ? colors.green500 : colors.green500Dark,
    light: isLightTheme ? colors.green100 : colors.green100Dark
  };
  const teal = {
    solid: isLightTheme ? colors.teal500 : colors.teal500Dark,
    light: isLightTheme ? colors.teal100 : colors.teal100Dark
  };
  const blue = {
    solid: isLightTheme ? colors.blue500 : colors.blue500Dark,
    light: isLightTheme ? colors.blue100 : colors.blue100Dark
  };
  const purple = {
    solid: isLightTheme ? colors.purple500 : colors.purple500Dark,
    light: isLightTheme ? colors.purple100 : colors.purple100Dark
  };
  const magenta = {
    solid: isLightTheme ? colors.magenta500 : colors.magenta500Dark,
    light: isLightTheme ? colors.magenta100 : colors.magenta100Dark
  };
  return [red, purple, amber, blue, lime, yellow, magenta, teal, orange, green];
}
export function getMutedColorShades(theme: Theme): HueShades {
  const isLightTheme = theme === 'Light';
  return {
    light: isLightTheme ? colors.gray200 : colors.gray200Dark,
    solid: isLightTheme ? colors.gray500 : colors.gray500Dark
  };
}
export function getNeutralColorShades(theme: Theme): HueShades {
  const isLightTheme = theme === 'Light';
  return {
    solid: isLightTheme ? colors.gray900 : colors.gray700Dark,
    light: isLightTheme ? colors.gray100 : colors.gray200Dark
  };
}